import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'
import { Loader2 } from 'lucide-react'

export default function AuthCallbackPage() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const { setTokens, fetchUser } = useAuthStore()

    useEffect(() => {
        const accessToken = searchParams.get('accessToken')
        const refreshToken = searchParams.get('refreshToken')
        const expiresAt = searchParams.get('expiresAt')

        if (accessToken && refreshToken && expiresAt) {
            setTokens(accessToken, refreshToken, parseInt(expiresAt))
            fetchUser().then(() => {
                navigate('/', { replace: true })
            })
        } else {
            const error = searchParams.get('error')
            navigate(`/login?error=${error || 'auth_failed'}`, { replace: true })
        }
    }, [searchParams, setTokens, fetchUser, navigate])

    return (
        <div className="flex flex-col items-center justify-center min-h-[400px]">
            <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
            <p className="text-muted-foreground">Completing sign in...</p>
        </div>
    )
}
